import PanelPage from 'navigation/pages/PanelPage';
import RowProductCard from 'sections/product/partials/RowProductCard';
import Form from 'components/form/Form';
import { bindMethod } from 'helpers/bind';
import scroll from 'core/scroll';
import anime from 'animejs';
import mqStore from 'store/mqStore';
import { frameToMs } from 'helpers/easings';
import { defer } from 'lodash-es';
import store from 'store';
import CheckoutFooter from './CheckoutFooter';
class CheckoutSummary extends PanelPage {
    bindEvents(add = true) {
        super.bindEvents(...arguments);
        const method = bindMethod(add);
        this.refs.summaryClose[method]('click', this.toggleSummary);
        this.refs.summaryOverlay[method]('click', this.toggleSummary);
        if (this.refs.clearCoupon)
            this.refs.clearCoupon[method]('click', this.clearCoupon);
        store.checkoutSummaryOpened.toggleListener(add, this.toggleSummary);
    }
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            products: ['.row-product-card', RowProductCard],
            checkoutFooter: ['.checkout-footer', CheckoutFooter],
            couponForm: ['.checkout-promo__form', Form]
        };
    }
    toggleSummary = () => {
        this.el.parentElement.classList.toggle('opened');
        const duration = 700;
        if (this.el.parentElement.classList.contains('opened')) {
            scroll.lock();
            this.refs.summaryWrapper.style.display = 'block';
            this.setProductsWrapperHeight();
            anime({
                targets: this.refs.summaryWrapper,
                translateY: ['100%', 0],
                easing: 'cubicBezier(0.645, 0.045, 0.355, 1)',
                duration
            });
        }
        else {
            anime({
                targets: this.refs.summaryWrapper,
                translateY: [0, '100%'],
                easing: 'cubicBezier(0.645, 0.045, 0.355, 1)',
                duration
            }).finished.then(() => {
                this.refs.summaryWrapper.style.display = 'none';
                scroll.unlock();
            });
        }
    };
    /* SHOW */
    async show(previousPage, previousEl) {
        this.resize();
        this.invoke('show');
        const isIdentical = previousEl?.innerHTML === this.el?.innerHTML;
        if (isIdentical)
            anime.set(this.el, { opacity: 1 });
        // const isSamePage = previousPage === this.pageName() && previousPage !== PanelPage.pageName
        await anime({
            targets: this.el,
            opacity: [0, 1],
            duration: frameToMs(15),
            easing: 'linear',
            delay: frameToMs(15),
            changeBegin: () => {
            },
            complete: () => {
                defer(() => this.resize());
            }
        }).finished;
    }
    async hide(nextPage, previousEl) {
        // this.el.classList.add('disappearing')
        const isIdentical = previousEl?.innerHTML === this.el?.innerHTML;
        if (isIdentical)
            return;
        await anime({
            targets: this.el,
            opacity: [1, 0],
            duration: frameToMs(15 / 2),
            easing: 'linear',
            delay: frameToMs(15)
        }).finished;
    }
    setProductsWrapperHeight() {
        const headerHeight = this.refs.summaryHeader.offsetHeight;
        const footerHeight = this.refs.summaryPromoTotals.offsetHeight;
        const productsHeight = this.refs.summaryProducts[0].offsetHeight;
        const substractHeight = headerHeight + footerHeight + 20;
        const totalHeight = headerHeight + footerHeight + productsHeight;
        const height = `calc(var(--ivh) - ${substractHeight}px)`;
        if (totalHeight < window.innerHeight)
            return;
        this.refs.summaryProducts[0].style.height = height;
    }
    resize() {
        super.resize();
        this.setProductsWrapperHeight();
        if (!mqStore.tabletPortrait.get()) {
            this.refs.summaryWrapper.style.display = 'block';
            this.refs.summaryWrapper.style.transform = 'translateY(0)';
        }
        else if (mqStore.tabletPortrait.get() && this.el.parentElement && !this.el.parentElement.classList.contains('opened')) {
            this.refs.summaryWrapper.style.display = 'none';
            this.refs.summaryWrapper.style.transform = 'translateY(var(--vh))';
        }
    }
    clearCoupon = () => {
        this.modules.couponForm.clear();
        this.modules.couponForm.submit().then(() => {
            this.modules.couponForm.setSubmitted(false);
        });
    };
}
export default CheckoutSummary;
